// 企业信息
export default {
    companyName: '企业名称',
    administrator: '管理员',
    contactInformation: '联系方式',
    authorizationModule: '授权模块',
    logoSettings: 'logo设置',
    logoUpload: 'logo上传',
    imageFormatWrong: '上传图片格式错误',
}
